module.exports = __webpack_public_path__ + "static/media/michael.777e9da0.jpg";